export default "__VITE_ASSET__DiYjvy4I__"